import { render, staticRenderFns } from "./GlobalPartnerCreate.vue?vue&type=template&id=3b672656&scoped=true"
import script from "./GlobalPartnerCreate.vue?vue&type=script&lang=js"
export * from "./GlobalPartnerCreate.vue?vue&type=script&lang=js"
import style0 from "./GlobalPartnerCreate.vue?vue&type=style&index=0&id=3b672656&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b672656",
  null
  
)

export default component.exports